import React from "react";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  Text,
  Flex,
} from "@chakra-ui/react";
import CustomButton from "../Button/CustomButton";
import { ReactComponent as AlertTriangleIcon } from "../../assets/alert-triangle.svg";
import Heading from "../Text/Heading";

const SidePanel = ({
  isOpen,
  onClose,
  title,
  bodyText,
  buttonLabel,
  onClick,
  headingLabel,
  alert,
}) => {
  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      size="sm"
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton color="#FFFFFF" marginTop="8px" />
        <DrawerHeader
          fontFamily="Nunito"
          fontSize="18px"
          lineHeight="32px"
          fontWeight="700"
          backgroundColor="#0E3665"
          color="#FFFFFF"
        >
          {title}
        </DrawerHeader>

        <DrawerBody padding={"0"}>
          <Flex justifyContent={"center"}>
            <Flex width={"88.57%"} flexDirection={"column"}>
              <Flex marginTop={"28px"}>
                <AlertTriangleIcon />
              </Flex>
              <Heading headingLabel={headingLabel}></Heading>
              <Text
                fontFamily={"Nunito"}
                fontWeight={"400"}
                fontSize={"13px"}
                lineHeight={"22px"}
                color={"#0E3665;"}
              >
                {bodyText}
              </Text>
            </Flex>
          </Flex>
        </DrawerBody>

        <DrawerFooter
          border="1px solid #ECEFF9"
          height="104px"
          justifyContent="center"
        >
          <CustomButton
            width="356px"
            backgroundColor={"#FF0000"}
            onClick={onClick}
            buttonLabel={buttonLabel}
          />
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default SidePanel;
